interface CrossIconProps {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
}

const CrossIcon: React.FC<CrossIconProps> = ({
  className,
  width = 30,
  height = 30,
  color = '#312e81'
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.92844 7.92898C8.4166 7.44082 9.20806 7.44082 9.69621 7.92898L22.0706 20.3033C22.5587 20.7915 22.5587 21.583 22.0706 22.0711C21.5824 22.5593 20.791 22.5593 20.3028 22.0711L7.92844 9.69674C7.44029 9.20859 7.44029 8.41713 7.92844 7.92898Z"
      fill={color}
    />
    <path
      d="M7.92844 22.0711C7.44029 21.583 7.44029 20.7915 7.92844 20.3033L20.3028 7.92898C20.791 7.44082 21.5824 7.44082 22.0706 7.92898C22.5587 8.41713 22.5587 9.20859 22.0706 9.69674L9.69621 22.0711C9.20805 22.5593 8.4166 22.5593 7.92844 22.0711Z"
      fill={color}
    />
  </svg>
);

export default CrossIcon;
